module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<label><input type="radio" name="section_' +
((__t = ( data.cid )) == null ? '' : __t) +
'" value="sales_refunds" ' +
((__t = ( data.section === "sales_refunds" ? "checked" : "" )) == null ? '' : __t) +
'></input> ' +
((__t = ( data.typeLabels.sales_refunds )) == null ? '' : __t) +
'</label>\n<label><input type="radio" name="section_' +
((__t = ( data.cid )) == null ? '' : __t) +
'" value="chargebacks" ' +
((__t = ( data.section === "chargebacks" ? "checked" : "" )) == null ? '' : __t) +
'></input> ' +
((__t = ( data.typeLabels.chargebacks )) == null ? '' : __t) +
'</label>\n';
 if (data.auths_search) { ;
__p += '\n<label><input type="radio" name="section_' +
((__t = ( data.cid )) == null ? '' : __t) +
'" value="authorizations" ' +
((__t = ( data.section === "authorizations" ? "checked" : "" )) == null ? '' : __t) +
'></input> ' +
((__t = ( data.typeLabels.authorizations )) == null ? '' : __t) +
'</label>\n';
 } ;

return __p
}